module.exports = __webpack_public_path__ + "img/logo.b82f6373.png";